import html2canvas from "html2canvas";
import i18n from "../../Translations";
import { jsPDF } from "jspdf";
import { colors } from "../../Theme/Colors";
import { nutrientsFullName } from "../../Utils/Consts";
import { FertigationRate } from "../../types";

export const createAgriPdf = (logoImage: string, footerImage: string, data: any, recommended: boolean) => {
    const input = document.getElementById("divToPrint")!;

    html2canvas(input).then((canvas) => {
        const x_startPoint = 40;
        const padding = 15;
        const initialYCoordinate = 55;

        const doc = new jsPDF("portrait", "px", "a4", false);

        doc.html(`<div>
            <h3>Test</h3>
        </div>`);

        doc.addImage(logoImage, "png", 180, 15, 89.25, 22);
        doc.setFont("Helvetica", "");
        doc.setFontSize(10);
        doc.text(`${i18n.t("PDFfile.mateData.createdBy")}`, x_startPoint, initialYCoordinate);
        doc.text(`${i18n.t("PDFfile.mateData.name")} ${data.name}`, x_startPoint, initialYCoordinate + padding);
        doc.text(`${i18n.t("PDFfile.mateData.location")} ${data.location}`, x_startPoint, initialYCoordinate + padding * 2);

        doc.text(`${i18n.t("PDFfile.mateData.phoneNumber")} ${data.phoneNumber}`, x_startPoint, initialYCoordinate + padding * 3);
        doc.text(`${i18n.t("PDFfile.mateData.Date")} ${data.date}`, x_startPoint, initialYCoordinate + padding * 4);
        doc.text(`${i18n.t("PDFfile.mateData.Time")} ${data.time}`, x_startPoint, initialYCoordinate + padding * 5);
        doc.text(data.bestSolutionFormula, x_startPoint, initialYCoordinate + padding * 6);

        doc.setFontSize(10);
        doc.text(data.bestSuitFormulaCoatings, 150, initialYCoordinate + padding * 6);
        doc.setFont("Helvetica", "bold");

        doc.text(`${i18n.t("PDFfile.summaryData.nutrientsApplied")} (${data.applicationVolume.mesurmentUnit})`, x_startPoint, initialYCoordinate + padding * 7);
        doc.setFont("Helvetica", "");

        doc.text(
            `${nutrientsFullName.n} ${data.formulaNutrients.n}  ${nutrientsFullName.p} ${data.formulaNutrients.p} ${nutrientsFullName.k} ${data.formulaNutrients.k}`,
            x_startPoint,
            initialYCoordinate + padding * 8
        );

        doc.setFont("Helvetica", "bold");
        doc.text(
            `${i18n.t("fmRecommendedProduct.volume")}: ${data.applicationVolume.value} ${data.applicationVolume.mesurmentUnit} | ${i18n.t(
                "fmRecommendedProduct.method"
            )}: ${i18n.t("pageStep3.inSoil")}`,
            x_startPoint,
            initialYCoordinate + padding * 10 - 5
        );
        doc.setFont("Helvetica", "");

        doc.text(`${i18n.t("PDFfile.descriptionRecommended")}`, x_startPoint, initialYCoordinate + padding * 11 - 10);
        doc.setFont("Helvetica", "bold");
        doc.text(`${i18n.t("PDFfile.summaryData.collectedDataTitle")}`, x_startPoint, initialYCoordinate + padding * 13);
        doc.text(`${i18n.t("PDFfile.summaryData.cropsTitle")}`, x_startPoint, initialYCoordinate + padding * 14);
        doc.setFont("Helvetica", "");
        doc.text(`${i18n.t("PDFfile.summaryData.cropProp")} ${data.crop}`, x_startPoint, initialYCoordinate + padding * 15);
        doc.text(
            `${i18n.t("PDFfile.summaryData.yieldProp")} ${data.yield.mesurmentUnit} ${data.yield.value} `,
            x_startPoint,
            initialYCoordinate + padding * 16
        );

        doc.text(`${i18n.t("PDFfile.summaryData.plantingDateProp")} ${data.plantingDate}`, x_startPoint, initialYCoordinate + padding * 17);

        doc.text(`${i18n.t("PDFfile.summaryData.harvestDateProp")} ${data.finalHarvestDate}`, x_startPoint, initialYCoordinate + padding * 18);

        doc.setFont("Helvetica", "bold");
        doc.text(`${i18n.t("PDFfile.summaryData.soilTitle")}`, x_startPoint, initialYCoordinate + padding * 19);
        doc.setFont("Helvetica", "");
        doc.text(`${i18n.t("PDFfile.summaryData.WaterRegimeProp")} ${data.water}`, x_startPoint, initialYCoordinate + padding * 20);
        doc.text(`${i18n.t("PDFfile.summaryData.soilProp")} ${data.soil}`, x_startPoint, initialYCoordinate + padding * 21);
        doc.setFont("Helvetica", "bold");
        !recommended && doc.text(`${i18n.t("PDFfile.summaryData.customizedTitle")}`, x_startPoint, initialYCoordinate + padding * 22);
        doc.setFont("Helvetica", "");
        !recommended && doc.text(`${i18n.t("PDFfile.summaryData.recipeCoatedTitle")}`, x_startPoint, initialYCoordinate + padding * 23);
        for (let i = 0; i < data.customized.coated.length; i++) {
            const name = data.customized.coated[i].name.replace(/(\r\n|\n|\r)/gm, " | ");
            !recommended && doc.text(`${name} ${data.customized.coated[i].precentage}%`, x_startPoint + 100, initialYCoordinate + padding * (23 + i));
        }
        !recommended && doc.text(`${i18n.t("PDFfile.summaryData.recipeUncoatedTitle")}`, x_startPoint, initialYCoordinate + padding * 26);

        for (let i = 0; i < data.customized.uncoated.length; i++) {
            const name = data.customized.uncoated[i].name.replace(/(\r\n|\n|\r)/gm, " | ");
            !recommended && doc.text(`${name} ${data.customized.uncoated[i].precentage}%`, x_startPoint + 100, initialYCoordinate + padding * (26 + i));
        }

        doc.setFont("Helvetica", "bold");
        recommended && doc.text(`${i18n.t("PDFfile.summaryData.recommended")}`, x_startPoint, initialYCoordinate + padding * 22);
        doc.setFont("Helvetica", "");
        recommended &&
            doc.text(
                `${i18n.t("PDFfile.summaryData.MaterialCodeProp")} ${data.recommendedSolution.materialCode}`,
                x_startPoint,
                initialYCoordinate + padding * 23
            );

        doc.addImage(footerImage, "png", x_startPoint, 600, 350, 20);
        doc.addPage("portrait");
        doc.addImage(logoImage, "png", x_startPoint, 15, 89.25, 22);
        doc.setTextColor(colors.primaryGreen);
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.releaseCurve.title"), x_startPoint, initialYCoordinate);
        doc.setTextColor(colors.defaultTextColor);
        doc.setFont("Helvetica", "");
        doc.text(i18n.t("PDFfile.releaseCurve.body"), x_startPoint, initialYCoordinate + padding);
        doc.addImage(canvas, x_startPoint - 10, initialYCoordinate + 30, 350, 100, "", "NONE", 0);

        doc.setTextColor(colors.primaryGreen);
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.howToUse.title"), x_startPoint, initialYCoordinate + 140);

        doc.setTextColor(colors.defaultTextColor);
        doc.setFont("Helvetica", "");
        doc.text(i18n.t("PDFfile.howToUse.body.firstLine"), x_startPoint, initialYCoordinate + 152);
        doc.text(i18n.t("PDFfile.howToUse.body.secondLine"), x_startPoint, initialYCoordinate + 152 + 12);
        doc.text(i18n.t("PDFfile.howToUse.body.thirdLine"), x_startPoint, initialYCoordinate + 176);
        doc.setFont("Helvetica", "bold");

        doc.text(i18n.t("PDFfile.howToUse.body.fourthLinePartOne"), x_startPoint, initialYCoordinate + 188);
        doc.setFont("Helvetica", "");

        doc.text(i18n.t("PDFfile.howToUse.body.fourthLinePartTwo"), 98, initialYCoordinate + 188);
        doc.setFont("Helvetica", "bold");

        doc.text(i18n.t("PDFfile.howToUse.body.fifthLinePartOne"), x_startPoint, initialYCoordinate + 200);
        doc.setFont("Helvetica", "");

        doc.text(i18n.t("PDFfile.howToUse.body.fifthLinePartTwo"), 82, initialYCoordinate + 200);
        doc.text(i18n.t("PDFfile.howToUse.body.fifthLinePartThree"), x_startPoint, initialYCoordinate + 212);

        doc.setTextColor(colors.primaryGreen);
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.when.title"), x_startPoint, initialYCoordinate + 224);

        doc.setFont("Helvetica", "");
        doc.setTextColor(colors.defaultTextColor);
        doc.text(i18n.t("PDFfile.when.body.firstLine"), x_startPoint, initialYCoordinate + 236);
        doc.text(i18n.t("PDFfile.when.body.secondLine"), x_startPoint, initialYCoordinate + 248);

        doc.setTextColor(colors.primaryGreen);
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.howMuch.title"), x_startPoint, initialYCoordinate + 260);

        doc.setFont("Helvetica", "");
        doc.setTextColor(colors.defaultTextColor);
        doc.text(i18n.t("PDFfile.howMuch.body.firstLine"), x_startPoint, initialYCoordinate + 272);
        doc.text(i18n.t("PDFfile.howMuch.body.secondLine"), x_startPoint, initialYCoordinate + 284);

        //waver title
        doc.setTextColor(colors.primaryGreen);
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.waver.title"), x_startPoint, initialYCoordinate + 296);
        //waver body
        doc.setFont("Helvetica", "");
        doc.setTextColor(colors.defaultTextColor);
        doc.text(i18n.t("PDFfile.waver.body.before"), x_startPoint, initialYCoordinate + 308);
        doc.text(i18n.t("PDFfile.waver.body.theGrower"), x_startPoint, initialYCoordinate + 320);
        doc.text(i18n.t("PDFfile.waver.body.isSold"), x_startPoint, initialYCoordinate + 332);
        doc.text(i18n.t("PDFfile.waver.body.orFitness"), x_startPoint, initialYCoordinate + 344);
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.waver.body.caution"), x_startPoint, initialYCoordinate + 356);
        doc.setFont("Helvetica", "");
        doc.text(i18n.t("PDFfile.waver.body.harmful"), x_startPoint + 43, initialYCoordinate + 356);

        //footer
        doc.addImage(footerImage, "png", x_startPoint, 600, 350, 20);
        doc.save(i18n.t("PDFfile.nameOfFile"));
    });
};

export const createMulticotePdf = (logoImage: string, footerImage: string, data: any) => {
    const input = document.getElementById("divToPrint")!;
    html2canvas(input).then((canvas) => {
        const x_startPoint = 40;
        const padding = 15;
        const initialYCoordinate = 55;
        const space = 12;
        const doc = new jsPDF("portrait", "px", "a4", false);
        doc.addImage(logoImage, "png", 180, 15, 89.25, 22);
        doc.setFont("Helvetica", "");
        doc.setFontSize(10);
        doc.text(`${i18n.t("PDFfile.mateData.createdBy")}`, x_startPoint, initialYCoordinate);
        doc.text(`${i18n.t("PDFfile.mateData.name")} ${data.name}`, x_startPoint, initialYCoordinate + padding);
        doc.text(`${i18n.t("PDFfile.mateData.phoneNumber")}`, x_startPoint, initialYCoordinate + padding * 2);
        doc.text(`${i18n.t("PDFfile.mateData.Date")} ${data.date}`, x_startPoint, initialYCoordinate + padding * 3);
        doc.text(`${i18n.t("PDFfile.mateData.Time")} ${data.time}`, x_startPoint, initialYCoordinate + padding * 4);
        doc.text(data.bestSolutionFormula, x_startPoint, initialYCoordinate + padding * 5);

        doc.setTextColor(colors.primaryGreen);
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.releaseCurve.title"), x_startPoint, initialYCoordinate + padding * 6);
        doc.setTextColor(colors.defaultTextColor);
        doc.setFont("Helvetica", "");
        doc.text(i18n.t("PDFfile.releaseCurve.body"), x_startPoint, initialYCoordinate + padding * 6 + 12);
        doc.addImage(canvas, x_startPoint - 10, initialYCoordinate + padding * 6 + 24, 350, 100, "NONE");

        doc.setTextColor(colors.primaryGreen);
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.howToUse.title"), x_startPoint, padding * 6 + 184);
        const point = padding * 6 + 24 + 160;
        let gap = 12;
        doc.setTextColor(colors.defaultTextColor);
        doc.setFont("Helvetica", "");
        doc.text(i18n.t("PDFfile.howToUse.body.firstLine"), x_startPoint, point + gap);
        gap = gap + space;
        doc.text(i18n.t("PDFfile.howToUse.body.forOptimalPerformance"), x_startPoint, point + gap);
        gap = gap + space;
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.howToUse.body.fourthLinePartOne"), x_startPoint, point + gap);
        doc.setFont("Helvetica", "");

        doc.text(i18n.t("PDFfile.howToUse.body.mixMulticote"), 98, point + gap);
        doc.setFont("Helvetica", "bold");
        gap = gap + space;
        doc.text(i18n.t("PDFfile.howToUse.body.secondBestPractice"), x_startPoint, point + gap);
        doc.setFont("Helvetica", "");

        doc.text(i18n.t("PDFfile.howToUse.body.forLate"), 145, point + gap);
        gap = gap + space;
        doc.text(i18n.t("PDFfile.howToUse.body.evenly"), x_startPoint, point + gap);
        gap = gap + space;
        doc.setTextColor(colors.primaryGreen);
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.howMuch.title"), x_startPoint, point + gap);
        gap = gap + space;
        doc.setFont("Helvetica", "");
        doc.setTextColor(colors.defaultTextColor);
        doc.text(i18n.t("PDFfile.howMuch.body.firstLine"), x_startPoint, point + gap);
        gap = gap + space;
        doc.text(i18n.t("PDFfile.howMuch.body.secondLine"), x_startPoint, point + gap);
        gap = gap + space;
        //waver title
        doc.setTextColor(colors.primaryGreen);
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.waver.title"), x_startPoint, point + gap);
        gap = gap + space;
        //waver body
        doc.setFont("Helvetica", "");
        doc.setTextColor(colors.defaultTextColor);
        doc.text(i18n.t("PDFfile.waver.body.before"), x_startPoint, point + gap);
        gap = gap + space;
        doc.text(i18n.t("PDFfile.waver.body.theGrower"), x_startPoint, point + gap);
        gap = gap + space;
        doc.text(i18n.t("PDFfile.waver.body.isSold"), x_startPoint, point + gap);
        gap = gap + space;
        doc.text(i18n.t("PDFfile.waver.body.orFitness"), x_startPoint, point + gap);
        gap = gap + space;
        doc.setFont("Helvetica", "bold");
        doc.text(i18n.t("PDFfile.waver.body.caution"), x_startPoint, point + gap);
        doc.setFont("Helvetica", "");
        doc.text(i18n.t("PDFfile.waver.body.harmful"), x_startPoint + 32, point + gap);

        //footer
        doc.addImage(footerImage, "png", x_startPoint, 600, 350, 20);
        doc.save(i18n.t("PDFfile.nameOfFile"));
    });
};

export const monthsNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const getCurrentMonthName = () => {
    const date = new Date();
    return `${monthsNames[date.getMonth()]} ${date.getDate()}`;
};

export async function delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function calculateFertigationRate(multicoteValue: number, traditionalValue: number): FertigationRate {
    const percentage = ((multicoteValue - traditionalValue) / multicoteValue) * 100;

    if (percentage > 30) return 5;
    if (percentage > 10 && percentage < 30) return 4;
    if (percentage > -10 && percentage < 10) return 3;
    if (percentage > -30 && percentage < -10) return 2;

    return 1;
}
